module.exports = "/_next/static/images/AIReadyData@2x-9f0b2884d7cdfd3a4077d5afc5fa6cc4.png";